<template>
    <div class="product-structure-tree">
        <ProductStructureTreeRow
            v-for="entry in visibleEntries"
            :key="entry.key"
            :entry="entry"
            :expanded="isExpanded(entry.key)"
            :busy="busyNodeKey === entry.key"
            @toggle="toggle"
            @add="$emit('add', $event)"
            @edit="$emit('edit', $event)"
            @remove="$emit('remove', $event)"
        />
    </div>
</template>

<script>
import ProductStructureTreeRow from './ProductStructureTreeRow.vue'

export default {
    name: 'ProductStructureTree',
    components: { ProductStructureTreeRow },
    props: {
        hierarchy: { type: Object, required: true },
        busyNodeKey: { type: String, default: null },
    },
    data() {
        return {
            collapsedByKey: {},
        }
    },
    computed: {
        visibleEntries() {
            if (!this.hierarchy || !this.hierarchy.id) {
                return []
            }

            const entries = []
            const append = (
                node,
                parent,
                depth,
                parentKey,
                isLastSibling,
                ancestorContinuations,
            ) => {
                const key = parentKey
                    ? `${parentKey}/${node.id}`
                    : `root:${node.id}`
                const entry = {
                    node,
                    parent,
                    depth,
                    key,
                    isRoot: parent === null,
                    isLastSibling,
                    ancestorContinuations,
                }

                entries.push(entry)

                if (!this.isExpanded(key)) {
                    return
                }

                const children = node.children || []
                children.forEach((child, childIndex) => {
                    const childIsLast = childIndex === children.length - 1
                    const childContinuations = depth === 0
                        ? []
                        : [...ancestorContinuations, !isLastSibling]

                    append(
                        child,
                        node,
                        depth + 1,
                        key,
                        childIsLast,
                        childContinuations,
                    )
                })
            }

            append(this.hierarchy, null, 0, '', true, [])
            return entries
        },
    },
    methods: {
        isExpanded(key) {
            return this.collapsedByKey[key] !== true
        },
        toggle(entry) {
            this.$set(this.collapsedByKey, entry.key, this.isExpanded(entry.key))
        },
    },
}
</script>

<style lang="scss" scoped>
.product-structure-tree {
    overflow: hidden;
    border: 1px solid #ebe9f1;
    border-radius: .357rem;
}
</style>
